import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5t38785gfm: FaireBrandEntity = {
  token: "b_5t38785gfm",
  type: "brand",
  name: "HEYDOH",
  avatarUrl:
    "https://cdn.faire.com/fastly/587df6c22b8b9dab39b83400a92e9de5a80fd5d4853dd5284e97ea93a9f09c77.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e22a1a8ef3a9a8de2b7fc6876576f1b296a5b8ecaee87fadaed1d42d8c21f846.png",
  logoUrl:
    "https://cdn.faire.com/fastly/587df6c22b8b9dab39b83400a92e9de5a80fd5d4853dd5284e97ea93a9f09c77.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e22a1a8ef3a9a8de2b7fc6876576f1b296a5b8ecaee87fadaed1d42d8c21f846.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "HEYDOH is a single-origin soy sauce brand based in Brooklyn, New York, with every bottle brewed and crafted in Taiwan. We use only non-GMO Taiwanese black soybeans—a rare varietal grown on small farms and bred specifically for fermentation. Naturally higher in antioxidants and protein than the common yellow soybean, they produce a sauce with deep, layered flavor, much like fine wine. \n\nWith clean ingredients, a transparent supply chain, and a true farm-to-bottle story, HEYDOH is the soy sauce that deserves a place alongside the premium olive oils and vinegars on your shelves.\n\nVegan and certified non-GMO by the non-GMO project! ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.916Z",
    importedBy: "entity-db-cli",
  },
};
